import { IReactionOptions, IReactionPublic, reaction } from 'mobx';
import RootStore from '../stores/RootStore';

export const safeReaction = <T extends {}>(
  rootStore: RootStore,
  expression: (r: IReactionPublic) => T,
  effect: (arg: T, prev: T, r: IReactionPublic) => void,
  opts?: IReactionOptions<T, boolean>,
) => {
  if (!rootStore.isNode) {
    reaction(expression, effect, opts);
  } else if (opts && opts.fireImmediately) {
    effect(expression(null), null, null);
  }
};
